export class PendingApplicationSearchModel {
  id: string;
  name: string;
  status: string;
  can_resend: boolean;
}
